import {
  put, takeLatest, all, select, call, takeEvery, fork,
} from 'redux-saga/effects';
import * as Actions from 'circe/authorization/actions';
import * as I18n from 'circe/I18n';
import { initProfiles, updateProfileToken } from 'circe/authorization/actions'; // TODO Should be here not in circe
import { logout, tokens as updateTokens } from 'circe/authentication/actions';
import { saveUserInLocalStorage } from 'circe/authentication/utils';
import { authClient, operatorClient } from 'domain/HttpClients';
import { delay } from 'redux-saga';
import { block as blockUI, unblock as unblockUI } from 'domain/layout/actions';
import {
  CognitoRefreshToken,
  CognitoUserPool,
  CognitoUserSession,
  CognitoUser,
} from 'amazon-cognito-identity-js';
import {
  selectProfile,
  profileInitialized,
  authorize,
  update as updateProfile,
} from 'domain/fuse/auth/profiles/actions';
import { AUTHORITIES } from 'domain/fuse/auth/constants';
import { PROFILE_STATUS, REFRESH_TOKENS_TIMEOUT } from 'domain/fuse/auth/profiles/constants';
import { getProfiles, getCurrentProfile } from 'domain/fuse/auth/selectors';
import {
  updateSelectedProfileStorage,
  getSelectedProfileFromStorage,
} from 'domain/fuse/auth/profiles/utils';
import { getUserFromLocalStorage } from 'domain/fuse/auth/utils';

function* doBootstrap() {
  const state = yield select();
  const isLoggedIn = state.circe.authentication.logged === true; // TODO selectors
  if (!isLoggedIn) {
    yield put(Actions.loadAuthorities([AUTHORITIES.VISITOR]));
  } else {
    let profile = getSelectedProfileFromStorage();
    try {
      hj('tagRecording', [state.circe.authentication.userData.email]);
    } catch (e) {}

    const { role, profileId } = profile;
    if (role && profileId) {
      yield put(Actions.loadAuthorities([AUTHORITIES.AUTHENTICATED, role]));
    } else {
      const profiles = getProfiles(state);
      if (profiles.length) {
        const active = profiles.filter((profile) => profile.status === PROFILE_STATUS.ACTIVE);
        if (active.length) {
          const activeDomainProfile = active.find((profile) => profile.domain === SYSTEM_DOMAIN);

          if (activeDomainProfile) {
            profile = activeDomainProfile;
          } else {
            [profile] = active;
          }
        } else {
          alert(
            I18n.str(
              'profileUnderReview',
              'Your profile is under review, we notified the admin about it and now you will be logged out',
            ),
          );
          yield put(logout());
        }
      } else {
        alert(I18n.str('noProfilesAlert', "You don't have any profile "));
      }
    }
    yield put(selectProfile(profile));
  }
}

function* doSelectProfile(action) {
  const {
    payload: { profile },
  } = action;
  const { status } = profile;
  if (status !== 'ACTIVE') return;
  yield fork(refreshTokens);
  updateSelectedProfileStorage(profile);
  const { role } = profile;

  yield put(Actions.loadAuthorities([role, AUTHORITIES.AUTHENTICATED]));

  yield put(authorize(profile.profileId));
}

function* refreshTokens() {
  const state = yield select();
  const profile = getCurrentProfile(state);
  const { tokens, ...rest } = getUserFromLocalStorage();
  const token = new CognitoRefreshToken({ RefreshToken: tokens.refreshToken });

  const cognitoUser = yield getCognitoUser(rest.email);
  const cognitoNewTokens = yield new Promise((resolve) => {
    cognitoUser.refreshSession(token, (err, session) => {
      resolve({
        accessToken: session.getAccessToken().getJwtToken(),
        idToken: session.getIdToken().getJwtToken(),
        refreshToken: session.getRefreshToken().getToken(),
      });
    });
  });
  const userData = { ...rest, ...tokens, tokens: cognitoNewTokens };
  saveUserInLocalStorage(userData);
  yield put(updateTokens(userData));
  yield put(authorize(profile.profileId));
  yield delay(REFRESH_TOKENS_TIMEOUT);
  yield refreshTokens();
}
// HARD DEPENDENCY SHUOLD BE REMOVEDE WITH THE NEW AUTH CHANGES
function* getCognitoUser(email) {
  const poolData = {
    UserPoolId: AWS_USER_POOL_ID,
    ClientId: AWS_USER_POOL_WEB_CLIENT_ID,
  };
  const userPool = new CognitoUserPool(poolData);
  const userData = {
    Username: email,
    Pool: userPool,
  };
  return new CognitoUser(userData);
}

function* authorizeProfile(action) {
  const {
    payload: { profileId },
  } = action;
  const state = yield select();
  const { idToken } = state.circe.authentication.tokens; // TODO selectors
  const headers = {
    Authorization: `Bearer ${idToken}`,
  };
  try {
    yield put(blockUI('AUTHORIZE_PROFILE'));
    const token = yield authClient
      .Get(`/api/authorization/profiles/${profileId}`)
      .withHeaders(headers)
      .send();

    yield put(updateProfileToken(profileId, token));
    const profile = getCurrentProfile(state) || {};

    yield put(updateProfile({ ...profile, token }));

    yield put(profileInitialized({ ...profile, token }));
  } catch (e) {
    throw e;
  } finally {
    yield put(unblockUI('AUTHORIZE_PROFILE'));
  }
}

function* doLogout() {
  updateSelectedProfileStorage({});
}

function* doUpdateCurrentProfileOnInitialize(action) {
  const { payload } = action;
  const { profile } = payload;

  const state = yield select();

  const currentProfile = getCurrentProfile(state) || {};

  if (profile.profileId !== currentProfile.profileId) {
    return;
  }

  updateSelectedProfileStorage(profile);
}

function* doFetchAccountToken(action) {
  const { payload } = action;

  const { profileId, token: accessToken } = payload;

  const state = yield select();

  const profile = getCurrentProfile(state);

  if (profile.profileId !== profileId || !accessToken) {
    return;
  }

  try {
    const accountToken = yield operatorClient.Get('/api/ops/account-token').send();

    yield put(
      updateProfile({
        accountToken,
      }),
    );
  } catch (error) {}
}

function* watcher() {
  yield all([
    takeLatest(initProfiles().type, doBootstrap),
    takeEvery(selectProfile().type, doSelectProfile),
    takeLatest(updateProfileToken().type, doFetchAccountToken),
    takeEvery(authorize().type, authorizeProfile),
    takeEvery(profileInitialized().type, doUpdateCurrentProfileOnInitialize),
    takeEvery(logout().type, doLogout),
  ]);
}

export default watcher;
